import { ParseDate } from './FormatHelpers'

export const SundayDate = () => {
  var sundayDate = new Date(2020, 3-1, 1, 0, 0, 0); 
  return sundayDate;
}

export const CreateDateString = (date) => {
  var dateString = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
  return dateString;
}

export function AvailableDay(date) {
    try {
        var today = new Date();
        var dateString = date.getFullYear() + "-" + ("0" + (date.getMonth()+1)).slice(-2) + "-" + ("0"+date.getDate()).slice(-2);
        this.date = dateString;
        this.closed = date < today ? true : false;
        this.available = date < today ? false : true;
        this.reasonCode = date < today ? 100 : 0;
        this.reason = date < today ? "Date in past" : "Day is available";
    } catch (e) {
        logException("AvailableDay", e);
    }
}

export const IsToday = (day, selectedDate) => {
    const today = new Date();
    var date = ParseDate(day.date);
    var isToday =
        date.getDate() == today.getDate() &&
        date.getMonth() == today.getMonth() &&
        date.getFullYear() == today.getFullYear();
    return isToday ? "today" : "";
}


export const IsSelected = (day, selectedDate) => {
    var date = ParseDate(day.date);
    var isSelected =
        date.getDate() == selectedDate.getDate() &&
        date.getMonth() == selectedDate.getMonth() &&
        date.getFullYear() == selectedDate.getFullYear();
    return isSelected ? "selected" : "";
}

export const IsAvailable = (day) => {
    if (day.available)
        return "";
    else
        return "disabled=disabled";
}

export const FirstDayOfMonth = (date) => {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export const LastDayOfMonth = (date) => {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

export const AddDaysToDate = (inputDate, days) => {
  var date = new Date(inputDate);
  date.setDate(inputDate.getDate()+days);
  return date;
}

export const timeFromMilitaryTime = (time, locale, hour24) => {
    var hours = time / 100;
    var mins = time % 100;
    var timeDate = new Date(1960, 10-1, 30, hours, mins, 0);
    return timeDate.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit', hour12: !hour24});
}

export const timeFromDisplayTime = displayTime => {
    var spaceIndex = displayTime.indexOf(" ");
    var time = displayTime.substr(0, spaceIndex);
    return time;
}
export const ampmFromDisplayTime = displayTime => {
    var spaceIndex = displayTime.indexOf(" ");
    var ampm = displayTime.substr(spaceIndex + 1);
    return ampm;
}

export const GetFirstCalendarDate = (date) => {
  // first get the beginning of month
  // then go backwards to sunday
  var firstDayOfMonth = FirstDayOfMonth(date);
  var dow = firstDayOfMonth.getDay();
  var weekStartDate = AddDaysToDate(firstDayOfMonth, -dow);
  return weekStartDate;
}

export const GetCalendarDays = (date) => {
  var totalCalendarWeeks = GetCalendarWeeks(date);
  return totalCalendarWeeks * 7;
}

export const GetCalendarWeeks = (date) => {
  var firstDay = FirstDayOfMonth(date);
  var lastDay = LastDayOfMonth(date);

  var dow = firstDay.getDay();
  var displayableMonthDaysWeekOne = 7 - dow;
  var remainingDisplayableDays = lastDay.getDate() - displayableMonthDaysWeekOne;
  var remainingDisplayableWeeks = Math.floor(remainingDisplayableDays / 7) + (remainingDisplayableDays % 7 > 0 ? 1 : 0);
  var totalDisplayableWeeks = remainingDisplayableWeeks + 1;
  return totalDisplayableWeeks;
}

export const StartBookingTimer = (timerContainer, timerMins, callback) => {
  const countDownDate = new Date().getTime() + (timerMins * 60000);
  
  const elTimerContainer = document.querySelector(timerContainer);
  
  const elTimer = document.createElement('SPAN');
  const timerUniqueId = new Date().getTime;
  
  elTimer.id = 'onsched-timer-countdown-' + timerUniqueId;
  elTimer.innerText = timerMins + ':00';

  elTimerContainer.innerHTML = '';
  elTimerContainer.append(elTimer);
  
  var x = setInterval(function() {
    const now = new Date().getTime();

    const distance = countDownDate - now;

    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    const timerBreak = seconds >= 10 ? ':' : ':0';
      
    elTimer.innerText = minutes + timerBreak + seconds;
      
    if (distance < 1) {
      clearInterval(x);
      callback();
    }
  }, 1000);
}
